import React, { useCallback, useMemo, useState } from 'react';

import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import { useSetRecoilState } from 'recoil';
import ClaimRewardsResultAtom from '../../../../recoil/cashout/ClaimRewardsResultAtom';
import useHttpRequest from '../../../api/HttpRequest';
import ItemConvertSubmission from './ItemConvertSubmission';
import ItemConvertSuccess from './ItemConvertSuccess';
import ClaimRewardProcessing from '../../common/ClaimRewardProcessing';
import ClaimRewardError from '../../common/ClaimRewardError';
import ClaimRewardsStatuses, { CONVERT_ORDER_FEATURE } from '../../common/Constants';

export default function ItemConvertConfirmationModal({ selectedPackage, onClose }) {
  const httpRequest = useHttpRequest();

  const setClaimRewardsResult = useSetRecoilState(ClaimRewardsResultAtom);

  const [status, setStatus] = useState(ClaimRewardsStatuses.idle);

  const sendOrder = useCallback(async (evt) => {
    evt?.preventDefault?.();

    // Prevent multiple submissions
    if (status !== ClaimRewardsStatuses.idle) return;

    setStatus(ClaimRewardsStatuses.processing);
    try {
      const result = await httpRequest.send(`/web-payments/${CONVERT_ORDER_FEATURE}/orders/${uuidv4()}`, {
        method: 'PUT',
        body: {
          productId: selectedPackage.productId,
        },
        additionalHeaders: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });

      console.log('Items order submitted successfully: ', result);
      setStatus(ClaimRewardsStatuses.success);
      setClaimRewardsResult({
        status: ClaimRewardsStatuses.success,
        updatedAt: Date.now(),
      });
    } catch (err) {
      console.log('Unable to submit items order due to: ', err);
      setStatus(ClaimRewardsStatuses.error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPackage]);

  const content = useMemo(() => {
    switch (status) {
      case ClaimRewardsStatuses.processing:
        return <ClaimRewardProcessing />;
      case ClaimRewardsStatuses.success:
        return <ItemConvertSuccess selectedPackage={selectedPackage} onClose={onClose} />;
      case ClaimRewardsStatuses.error:
        return <ClaimRewardError onClose={onClose} />;
      default:
        return (
          <ItemConvertSubmission
            selectedPackage={selectedPackage}
            handleSubmit={sendOrder}
            handleClose={onClose}
          />
        );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, selectedPackage]);

  return (
    <div
      id="item-convert-confirmation"
      className="phoenix-simple-dialog-view modal member-diamonds-cash-confirm show"
      aria-hidden="false"
    >
      <div className="modal-backdrop fade" />
      <div className="modal-dialog">
        <div className="modal-content modal-content-sm">
          {content}
        </div>
      </div>
    </div>
  );
}

ItemConvertConfirmationModal.propTypes = {
  selectedPackage: PropTypes.shape({
    productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};
